/** @typedef	{import('./Props').default} Props */

import { BaseSVG } from '../../BaseSVG';
import { translate } from '../../../App/Internationalization';
import ExternalAnchorButton from '../../ExternalAnchorButton';
import images from '../../../config/local/images';
import React from 'react';
import SubscriptionPoints from '../SubscriptionPoints';

/**
 * @param {Props} props
 * @returns {JSX.Element}
 */
function SubscriptionCardEnterprise(props) {
	return (
		<section className="flex flex-col gap-4 lg:grid lg:grid-cols-3 lg:gap-28 lg:col-span-full border border-theme-dark rounded-lg w-full p-10 lg:h-fit">
			<i className="flex h-24 w-40 lg:h-auto lg:w-full icon lg:p-8">
				<BaseSVG
					className="h-fit"
					path={images.icons.subscriptionPlans[props?.tier?.title]}
				/>
			</i>

			<div className="flex flex-col gap-5">
				<p className="font-bold text-ms-4">
					{translate(
						`subscription.plans.${props?.tier?.title}.title`
					)}
				</p>

				<p className="lg:min-h-[7rem] font-medium">
					{props?.tier?.description}
				</p>

				<ExternalAnchorButton
					className="button w-full p-3 text-ms-3"
					href="https://share.hsforms.com/1D5IxINT8TqOtqs86wkWVuAe0kgx"
					target="_blank"
				>
					{translate('subscription.plans.contact_us')}
				</ExternalAnchorButton>
			</div>

			<div>
				{translate('subscription.plans.additional_features')}
				<SubscriptionPoints features={props?.tier?.features} />
			</div>
		</section>
	);
}

export default React.memo(SubscriptionCardEnterprise);
